import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Typography,
  IconButton,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

const pillars = [
  {
    label: 'Calidad de datos',
    weight: '25%',
    desc: 'Verificamos contra fuentes oficiales del emisor, agregadores regulados y documentos públicos.',
  },
  {
    label: 'Valor financiero',
    weight: '25%',
    desc: 'Analizamos cuotas, tasas, bonos y costo real a 12 meses para el perfil newcomer.',
  },
  {
    label: 'Accesibilidad newcomer',
    weight: '25%',
    desc: 'Evaluamos requisitos de crédito, programas newcomer, ventana de elegibilidad y facilidad de aplicación.',
  },
  {
    label: 'Experiencia de usuario',
    weight: '25%',
    desc: 'App móvil, banca digital, red ATM, servicio en español y velocidad de aprobación.',
  },
];

/**
 * Modal explaining how FinMaple Score is calculated.
 * Opened from "¿Cómo calculamos esto?" link next to score badges.
 */
const ScoringExplainerModal = ({ open, onClose }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={isMobile}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: isMobile ? 0 : '14px' } }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 700, fontSize: '1rem' }}>
          ¿Cómo calculamos el FinMaple Score?
        </Typography>
        <IconButton onClick={onClose} size="small" aria-label="Cerrar">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ pt: 2, pb: 3 }}>
        <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2.5, lineHeight: 1.7 }}>
          El FinMaple Score es una puntuación de 0 a 100 basada en cuatro pilares igualmente ponderados.
          No aceptamos pago por mejorar puntuaciones.
        </Typography>

        {pillars.map((p, i) => (
          <Box
            key={i}
            sx={{
              mb: 2,
              p: 2,
              bgcolor: 'neutral.50',
              borderRadius: 2,
              border: '1px solid',
              borderColor: 'divider',
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
              <Typography variant="subtitle2" sx={{ fontWeight: 700, color: 'primary.main' }}>
                {p.label}
              </Typography>
              <Typography variant="caption" sx={{ fontWeight: 600, color: 'warning.main' }}>
                {p.weight}
              </Typography>
            </Box>
            <Typography variant="caption" sx={{ color: 'text.secondary', lineHeight: 1.5 }}>
              {p.desc}
            </Typography>
          </Box>
        ))}

        <Typography variant="caption" sx={{ display: 'block', color: 'text.disabled', mt: 1, textAlign: 'center' }}>
          Metodología completa en finmaple.com/como-monetizamos
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default ScoringExplainerModal;
